import React, { useState } from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';
import { routes } from '@vlabs/shared/navigation/routes';
import {
  Control, openConfirmPopup, Breadcrumbs, Breadcrumb,
} from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useParams, generatePath, useHistory } from 'react-router-dom';

import { NotificationForm } from './forms/NotificationForm';
import st from './NotificationCreateEditPage.module.sass';
import { deleteNotification } from './store';

function NotificationCreateEditComponent({ needVA = true, deletion = undefined }) {
  const { t } = useTranslation();
  const { notificationId } = useParams();
  const history = useHistory();

  const [notificationName, setNotificationName] = useState();

  const onDelete = () => {
    const title = t('vlNotifier:confirmation.delete.title');
    const message = t('vlNotifier:confirmation.delete.full_text', { name: notificationName });

    const onConfirm = () => {
      deletion(notificationId);
      history.push(generatePath(routes.notifications.all));
    };

    openConfirmPopup({
      title,
      message,
      type: 'delete',
      onConfirm,
    }, { className: st.Popup });
  };

  const actions = (
    <div className={st.Actions}>
      <Control.Button
        form="NotificationForm"
        type="submit"
        variant="filled"
      >
        {t('vlNotifier:form.submit')}
      </Control.Button>
      {notificationId !== 'create' && (
        <Control.Button
          kind="negative"
          onClick={onDelete}
          variant="filled"
        >
          {t('btn.delete')}
        </Control.Button>
      )}
    </div>
  );

  const breadcrumbs = (
    <Breadcrumbs>
      <Breadcrumb
        caption={t('vlNotifier:breadcrumbs.notification_settings')}
        href={generatePath(routes.notifications.all)}
      />
      <Breadcrumb caption={notificationName} />
    </Breadcrumbs>
  );

  const title = notificationId === 'create'
    ? t('vlNotifier:form.title_create_new')
    : notificationName;

  return (
    <Page>
      <PageContent>
        <PageHeader
          actions={actions}
          breadcrumbs={breadcrumbs}
          title={title}
        />
        <NotificationForm
          needVA={needVA}
          setNotificationName={setNotificationName}
        />
      </PageContent>
    </Page>
  );
}

NotificationCreateEditComponent.propTypes = {
  needVA: PropTypes.bool,
  deletion: PropTypes.func,
};

export const NotificationCreateEditPage = connect(
  null,
  (dispatch) => ({
    deletion: (id) => dispatch(deleteNotification(id)),
  }),
)(NotificationCreateEditComponent);
